import React, { Component } from 'react';
import { Select } from 'antd';
import _ from 'lodash';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import style from './style.scss';

import TimeSelect from 'Components/common/DeliveryTimeSelect/DeliveryTimeSelect';

export default class DeliveriesListItem extends Component{

  constructor(props) {
    super(props);

    const {app_data, delivery, date_moment} = props;

    let time_start = '00:00';
    let time_end = '00:00';

    if(delivery.time.length) {

      const time_split = delivery.time.split('-');

      time_start = time_split[0] || time_start;
      time_end = time_split[1] || time_end;

    }

    this.state = {
      type_id: delivery.type_id || Object.keys(app_data.delivery_types)[0],
      lead_id: delivery.lead_id || '',
      comment: delivery.comment || '',
      address: delivery.address || '',
      phone: delivery.phone || '',
      user_id: delivery.user_id || '',
      contractor_id: delivery.contractor_id || '',
      status_id: delivery.status_id || Object.keys(app_data.delivery_statuses)[0],
      time: delivery.time || '',
      time_start: time_start,
      time_end: time_end
    };

    this.throttleUpdateDelivery = _.debounce(this.updateDelivery, 1500);

  }


  componentWillReceiveProps(){

  }

  updateDelivery(variables) {

    const {updateDelivery, refetchDeliveries, delivery} = this.props;

    updateDelivery({
      variables: {
        ...variables,
      }
    }).then(() => {
      refetchDeliveries();
    });
  }

  isDeliveryPropsHidden = (editNotPermitted) => {
    if(!editNotPermitted) {
      return false;
    }

    const { delivery, app_data } = this.props;
    return delivery.user_id !== app_data.user.id;
  }

  isPhoneHidden = (editNotPermitted) => {
    if(!editNotPermitted) {
      return false;
    }

    const { delivery, app_data: {
      constants
    } } = this.props;
    return delivery.status_id !== constants.delivery.IN_PROGRESS;
  }

  is_text_for_fields = (delivery_type, delivery) => {

    const {
      app_data: {
        user: {
          access
        },
        constants: {
          delivery: {
            IN_PROGRESS,
          }
        }
      },
      date_moment,
      canOpen
    } = this.props;

    const delivery_access = access.delivery || {};

    // выбранный в интерфейсе день раньше текущего
    const selected_day_Is_previous = moment().startOf('day').isAfter(date_moment);

    const dont_edit_previos_day = !access.deliveries.edit_old && selected_day_Is_previous;

    const editNotPermitted = !(delivery_access.all);

    const cantChangeStatus = delivery.status_id !== IN_PROGRESS && (!canOpen && !delivery_access.all);
    const cantChangeDriver = delivery.user_id !== null && !delivery_access.all;

    const fields_is_text = {
      type: editNotPermitted,
      lead: editNotPermitted,
      delivery_info_hidden: this.isDeliveryPropsHidden(editNotPermitted),
      contractor: editNotPermitted,
      time: editNotPermitted,
      address: editNotPermitted,
      address_hidden: this.isDeliveryPropsHidden(editNotPermitted),
      phone: editNotPermitted,
      phone_hidden: this.isPhoneHidden(editNotPermitted),
      comment: editNotPermitted,
      driver: dont_edit_previos_day || cantChangeDriver,
      status: dont_edit_previos_day || cantChangeStatus,
    };

    switch (delivery_type) {
      case 'act':
        return {
          ...fields_is_text,
          address: true,
          phone: true,
        };
      case 'other':
      case 'evening':
        return {
          ...fields_is_text
        };
      case 'contractor':
        return {
          ...fields_is_text,
          address: true,
          phone: true,
        };
    }
  };

  onDeliveryChange = (data) => {

    const { delivery } = this.props;

    const time_start = data.time_start || this.state.time_start;
    const time_end = data.time_end || this.state.time_end;

    const time = [time_start, time_end].join('-');


    this.setState({
      time,
      ...data
    });

    const update_data = {
      id: delivery.id,
      time,
      ...data
    };

    if (data.comment) {
      this.throttleUpdateDelivery({
        id: delivery.id,
        comment: data.comment,
      });
      return;
    }

    if (data.time_start || data.time_end) {
      this.updateDelivery({
        id: delivery.id,
        time,
      });
      return;
    }

    this.updateDelivery({
      id: delivery.id,
      ...data,
    });
  };

  onStatusChange = (status_id) => {

    const { delivery } = this.props;

    if(!confirm('Изменить статус доставки?')) {
      return true;
    }

    this.setState({
      status_id
    });

    this.updateDelivery({
      id: delivery.id,
      status_id
    });

  };

  removeDelivery = () => {
    const {delivery, removeDelivery, refetchDeliveries} = this.props;

    if(!confirm('Удалить доставку?')) {
      return true;
    }

    removeDelivery({
      variables: {
        id: delivery.id
      }
    }).then(() => {
      refetchDeliveries();
    });
  };

  render() {

    const {delivery, app_data} = this.props;

    const delivery_type = app_data.delivery_types[this.state.type_id];

    const delivery_access = app_data.user.access.delivery;

    const {
      COMPLETED,
      IN_PROGRESS,
      CANCELED
    } = app_data.constants.delivery;

    let delivery_status_class = '';

    switch (this.state.status_id*1) {
      case COMPLETED:

        delivery_status_class = 'completed';

        break;

      case IN_PROGRESS:

        delivery_status_class = 'in_progress';

        break;

      case CANCELED:

        delivery_status_class = 'canceled';

        break;
    }



    switch (delivery_type.type) {
      case 'act':
        return (
          <ClientDelivery
            onDeliveryChange={this.onDeliveryChange}
            onStatusChange={this.onStatusChange}
            type_id={this.state.type_id}
            lead_id={this.state.lead_id}
            user_id={this.state.user_id}
            status_id={this.state.status_id}
            time_start={this.state.time_start}
            time_end={this.state.time_end}
            comment={this.state.comment}
            delivery={delivery}
            app_data={app_data}
            fields_is_text={this.is_text_for_fields(delivery_type.type, delivery)}
            removeDelivery={this.removeDelivery}
            delivery_access={delivery_access}
            delivery_status_class={delivery_status_class}

          />
        );
        break;
      case 'other':
      case 'evening':
        return (
          <OtherDelivery
            onDeliveryChange={this.onDeliveryChange}
            onStatusChange={this.onStatusChange}
            type_id={this.state.type_id}
            user_id={this.state.user_id}
            status_id={this.state.status_id}
            time_start={this.state.time_start}
            time_end={this.state.time_end}
            comment={this.state.comment}
            address={this.state.address}
            phone={this.state.phone}
            delivery={delivery}
            app_data={app_data}
            fields_is_text={this.is_text_for_fields(delivery_type.type, delivery)}
            removeDelivery={this.removeDelivery}
            delivery_access={delivery_access}
            delivery_status_class={delivery_status_class}
          />
        );
        break;
      case 'contractor':
        return (
          <ContractorDelivery
            onDeliveryChange={this.onDeliveryChange}
            onStatusChange={this.onStatusChange}
            type_id={this.state.type_id}
            lead_id={this.state.lead_id}
            user_id={this.state.user_id}
            status_id={this.state.status_id}
            time_start={this.state.time_start}
            time_end={this.state.time_end}
            contractor_id={this.state.contractor_id}
            comment={this.state.comment}
            delivery={delivery}
            app_data={app_data}
            fields_is_text={this.is_text_for_fields(delivery_type.type, delivery)}
            removeDelivery={this.removeDelivery}
            delivery_access={delivery_access}
            delivery_status_class={delivery_status_class}
          />
        );
        break;

    }



  }
}

const ClientDelivery = ({
  type_id,
  lead_id,
  time_start,
  time_end,
  comment,
  user_id,
  delivery,
  onDeliveryChange,
  onStatusChange,
  removeDelivery,
  app_data,
  fields_is_text,
  delivery_access,
  status_id,
  delivery_status_class
}) => {

  const delivery_device = (delivery.lead) ? `${delivery.lead.remonline_device} ${delivery.lead.remonline_model}` : 'Устройство не установлено';

  const address = (delivery.lead && delivery.lead.client) ? delivery.lead.client.address : '';

  const phone = (delivery.lead && delivery.lead.client) ? delivery.lead.client.phone : '';

  return (
    <div className={`delivery ${delivery_status_class}`}>

      <div className="delivery__type_time">
        {!fields_is_text.delivery_info_hidden && <TypeSelect
          value={type_id}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.type}
        />}

        <TimeSelect
          value_start={time_start}
          value_end={time_end}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.time}
        />
      </div>


      <div className="delivery__device">
        {!fields_is_text.delivery_info_hidden && <LeadSelect
          value={lead_id}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.lead}
        />}

        {!fields_is_text.delivery_info_hidden && <div className="">
          <div className="label">Устройство</div>
          {delivery_device}
        </div>}


        {!fields_is_text.address_hidden && <Address
          value={address}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.address}
        />}

        {!fields_is_text.phone_hidden && <Phone
          value={phone}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.address}
        />}


      </div>


      <div className="delivery__comment_driver_remove">
        {!fields_is_text.delivery_info_hidden && <Comment
          value={comment}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.comment}
        />}

        <DriverSelect
          value={user_id}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.driver}
        />

        {(!fields_is_text.status && !fields_is_text.address_hidden) && <StatusChanger
          value={status_id}
          onChange={onStatusChange}
          app_data={app_data}
        />}


        {delivery_access.all && <RemoveBtn
          onClick={removeDelivery}
        />}

      </div>


    </div>
  )

};


const ContractorDelivery  = ({
  type_id,
  lead_id,
  time_start,
  time_end,
  comment,
  user_id,
  contractor_id,
  delivery,
  onDeliveryChange,
  onStatusChange,
  removeDelivery,
  app_data,
  fields_is_text,
  delivery_access,
  status_id,
  delivery_status_class
}) => {

  const contractor = app_data.contractors[contractor_id] || {};

  const address = contractor.address;

  const phone = contractor.phone;

  return (
    <div className={`delivery contractor_type ${delivery_status_class}`}>

      <div className="delivery__type_time">
        {!fields_is_text.delivery_info_hidden && <TypeSelect
          value={type_id}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.type}
        />}


        <TimeSelect
          value_start={time_start}
          value_end={time_end}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.time}
        />

      </div>


      <div className="delivery__device">

        {!fields_is_text.delivery_info_hidden && <ContractorSelect
          value={contractor_id}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.contractor}
        />}

        <div> </div>

        {!fields_is_text.address_hidden && <Address
          value={address}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.address}
        />}

        {!fields_is_text.phone_hidden && <Phone
          value={phone}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.phone}
        />}
      </div>

      <div className="delivery__comment_driver_remove">
        {!fields_is_text.delivery_info_hidden && <Comment
          value={comment}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.comment}
        />}

        <DriverSelect
          value={user_id}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.driver}
        />

        {(!fields_is_text.status && !fields_is_text.address_hidden) && <StatusChanger
          value={status_id}
          onChange={onStatusChange}
          app_data={app_data}
        />}

        {delivery_access.all && <RemoveBtn
          onClick={removeDelivery}
        />}
      </div>

    </div>
  )

};

const OtherDelivery  = ({
  type_id,
  time_start,
  time_end,
  comment,
  user_id,
  phone,
  address,
  onDeliveryChange,
  onStatusChange,
  removeDelivery,
  app_data,
  fields_is_text,
  delivery_access,
  status_id,
  delivery_status_class
}) => {



  return (
    <div className={`delivery other_type ${delivery_status_class}`}>

      <div className="delivery__type_time">
        {!fields_is_text.delivery_info_hidden && <TypeSelect
          value={type_id}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.type}
        />}


        <TimeSelect
          value_start={time_start}
          value_end={time_end}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.time}
        />
      </div>

      <div className="delivery__device">
        {!fields_is_text.address_hidden && <Address
          value={address}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.address}
        />}

        {!fields_is_text.phone_hidden && <Phone
          value={phone}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.phone}
        />}
      </div>

      <div className="delivery__comment_driver_remove">
        {!fields_is_text.delivery_info_hidden && <Comment
          value={comment}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.comment}
        />}

        <DriverSelect
          value={user_id}
          onChange={onDeliveryChange}
          app_data={app_data}
          is_text={fields_is_text.driver}
        />

        {(!fields_is_text.status && !fields_is_text.address_hidden) && <StatusChanger
          value={status_id}
          onChange={onStatusChange}
          app_data={app_data}
        />}

        {delivery_access.all && <RemoveBtn
          onClick={removeDelivery}
        />}

      </div>


    </div>
  )

};

const TypeSelect = ({value, onChange, app_data, is_text}) => {
  return <div className={style.delivery__type}>
    <div className="label">Тип доставки</div>

    {is_text && app_data.delivery_types[value].title}

    {!is_text && <select value={value} onChange={(e) => {
      onChange({
        type_id: e.target.value
      })
    }}>

      {Object.keys(app_data.delivery_types).reduce((acc, key) => {
        const type = app_data.delivery_types[key];
        if(!type.disabled){
          acc = [
            ...acc,
            <option key={key} value={type.id}>{type.title}</option>
          ];
        }
        return acc;
      }, [])}

    </select>}



  </div>;

};

const LeadSelect = ({value, onChange, app_data, is_text}) => {

  const leads_hash = _.reduce(app_data.leads, (hash, lead) => {

    hash[lead.id] = lead;

    return hash;
  }, {});

  const lead_text = leads_hash[value] ? leads_hash[value].act_number:'';
  let leadsOptions = app_data.leads.map((lead) => ({
    label: lead.act_number,
    value: lead.id,
  }));
  leadsOptions = [{ label: '', value: '' }].concat(leadsOptions);
  return <div className={style.delivery__type}>

    <div className="label">Номер акта</div>

    {is_text && lead_text}

    {!is_text && <Select 
      value={value} 
      onChange={(value) => {
        onChange({
          lead_id: value
        })
      }}
      style={{
        width: '100%'
      }}
      filterOption={(input, option) =>
        option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      showSearch
      virtual={true}
      options={leadsOptions}
    />}



  </div>;

};




const ContractorSelect = ({value, onChange, app_data, is_text}) => {


  const contractor_text = app_data.contractors[value] ? app_data.contractors[value].title : '';

  return <div className={style.delivery__type}>

    <div className="label">Подрядчик</div>

    {is_text && contractor_text}

    {!is_text && <select value={value} onChange={(e) => {
      onChange({
        contractor_id: e.target.value
      })
    }}>

      <option key={''} value={''}></option>

      {Object.keys(app_data.contractors).map(key => {

        const contractor = app_data.contractors[key];

        return <option key={contractor.id} value={contractor.id}>{contractor.title}</option>

      })}

    </select>}



  </div>;

};

const Comment = ({value, onChange, app_data, is_text}) => {


  return <div className={style.delivery__type}>

    <div className="label">Комментарий</div>

    {is_text && value}

    {!is_text && <textarea rows="3" value={value} placeholder="Комментарий: дюймы, номера актов и т.д." onChange={(e) => {
      onChange({
        comment: e.target.value
      })
    }}>

    </textarea>}

  </div>;

};

const Address = ({value, onChange, app_data, is_text}) => {


  return <div className={style.delivery__type}>
    <div className="label">Адрес</div>

    {is_text ?
      <div>
        <a href={`https://maps.yandex.ru?text=${value}`}>{value}</a>
      </div> :
      <textarea rows="3" value={value} placeholder="Адрес доставки" onChange={(e) => {
        onChange({
          address: e.target.value
        })
      }}>
      </textarea>
    }




  </div>;

};


const Phone = ({value, onChange, app_data, is_text}) => {

  let phone_component;

  if(is_text) {

    if(typeof value != 'string') {

      phone_component = value &&
        value.length &&
        value.map(phone => {

          const phone_blr = phone
            .replace(/^375/, '80')
            .replace(/^\+375/, '80');

          return <div key={phone_blr}>
            <a href={`tel:${phone_blr}`}>
              {phone_blr}
            </a>
          </div>
        });
    } else {

      phone_component = <div>
        {value}
      </div>;

    }


  } else {

    phone_component = (
      <textarea
        rows="3"
        value={value}
        placeholder="Телефоны"
        onChange={(e) => {
        onChange({
          phone: e.target.value
        })
      }}>
      </textarea>
    );
  }


  return <div className={style.delivery__type}>
    <div className="label">Телефон</div>

    {phone_component}


  </div>;

};

const DriverSelect = ({value, onChange, app_data, is_text}) => {
  const drivers_hash = _.keyBy(app_data.drivers, 'id');
  const driver_text = drivers_hash[value] ? drivers_hash[value].name : 'Не выбран';
  const role = app_data.roles[app_data.user.role_id];
  const isDriver = role.name === 'driver';
  const displayedDrivers = isDriver 
    ? app_data.drivers.filter(({ id }) => id === app_data.user.id)
    : app_data.drivers;
  return <div className={style.delivery__type}>

    <div className="label">Курьер</div>

    {is_text ? <div>
      {driver_text}
    </div> : <select value={value} onChange={(e) => {
      onChange({
        user_id: e.target.value ? e.target.value : null,
      })
    }}>

      <option key={''} value={''}></option>

      {displayedDrivers.map(driver => {

        return <option key={driver.id} value={driver.id}>{driver.name}</option>

      })}

    </select>}



  </div>;

};

const StatusChanger = ({value, onChange, app_data, is_text}) => {

  const {
    INITIALIZED,
    COMPLETED,
    IN_PROGRESS,
    CANCELED
  } = app_data.constants.delivery;

  let status_component;

  const button_cancel = (<div
    className="button button_gray button_big"
    onClick={(e) => {
      onChange(CANCELED)
    }}
  >
    Отменить
  </div>);

  if(app_data.user.access.delivery.all) {

    status_component = (
      <select
        value={value}
        onChange={(e) => {
          onChange(e.target.value)
        }}
      >

      {Object.keys(app_data.delivery_statuses).map(key => {

        const status = app_data.delivery_statuses[key];

        return <option key={status.id} value={status.id}>{status.title}</option>

      })};

    </select>);

  } else {

    let button;

    switch(value*1) {

      case INITIALIZED:

        button = (<div
          className="button button_green button_big"
          onClick={(e) => {
            onChange(IN_PROGRESS)
          }}
        >
          Выехал
        </div>);

        break;

      case IN_PROGRESS:

        button = (<div
          className="button button_green button_big"
          onClick={(e) => {
            onChange(COMPLETED)
          }}
        >
          Завершить
        </div>);

        break;

    }



    status_component = <div>
      {button}
      {button_cancel}
    </div>;

  }

  return <div className={style.delivery__type}>

      {status_component}

  </div>;

};


const RemoveBtn = ({onClick}) => {


  return <div className='button button_red button_big' onClick={onClick}>
    Удалить
  </div>;

};